import pl from "@locales/ai_onboarding/pl.json";
import en from "@locales/ai_onboarding/en.json";

export default {
  pl: pl,
  en: en,
};
